import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBox = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "m19.5831 8.1899-5.5499-3.9941-1.1683 1.6233 3.0326 2.1825H8.0982l3.0325-2.1825-1.1683-1.6233L4.4126 8.19l-.416.2994.0001.5125.0023 10 .0003.9998H19.999V8.4892l-.4159-.2993zM5.9969 10.0016H17.999v8H5.9988l-.0019-8zM10 14.0006h3.9999v-2h-4v2z",
		fill: "#111"
	})
});
export default SvgBox;
